const errorCodeMessages = {
  UNAUTHORIZED_ROLE: {
    title: 'Access Restricted',
    message: 'You do not have the required role to perform that action.'
  },
  UNAUTHORIZED_ORG_ACCESS: {
    title: 'Organization Access Denied',
    message: 'You are not authorized to access data for this organization.'
  },
  UNAUTHORIZED_ORG_UPDATE: {
    title: 'Organization Update Denied',
    message: 'You are not authorized to update this organization.'
  },
  UNAUTHORIZED_ROLE_ORG_ASSIGNMENT: {
    title: 'Role Assignment Denied',
    message: 'You cannot assign roles for an organization you do not administer.'
  },
  VALIDATION_ERROR: {
    title: 'Validation Error',
    message: 'Some provided information is invalid. Please review and try again.'
  },
  ALREADY_EXISTS: {
    title: 'Already Exists',
    message: 'A record with that unique value already exists. Edit the existing record instead.'
  },
  RATE_LIMITED: {
    title: 'Rate Limited',
    message: 'Too many unauthorized attempts. Please wait before retrying.'
  }
};

export default errorCodeMessages;
